// extracted by mini-css-extract-plugin
export default {"PageLoader":"PageLoader_PageLoader__Mhyft"};